import { action } from 'satcheljs/lib/legacy';
import moveToStore from '../store/store';
/**
 * Sets the isFocusInSearchBox
 * @param isFocusInSearchBox indicates whether the focus is in search box or not
 */
export default action('setIsFocusInSearchBox')(function setIsFocusInSearchBox(isFocusInSearchBox) {
    moveToStore.isFocusInSearchBox = isFocusInSearchBox;
});
//# sourceMappingURL=setIsFocusInSearchBox.js.map